import styled from '@emotion/styled';
import { N200 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var FeedSection = styled.section({
  width: '100%',
  marginTop: "var(--ds-space-200, 16px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var GroupHeadingWrapper = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: "var(--ds-space-075, 6px)",
  minHeight: '17px' // Prevents vertical shift when showing 'Mark all as read'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var SectionWrapper = styled.section({
  marginBottom: "var(--ds-space-075, 6px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var TimeGroupHeading = styled.h3({
  fontSize: '12px',
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '-0.01em'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var ButtonContainer = styled.span({
  fontSize: '12px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var BlankSkeletonPlaceholder = styled.div({
  width: '100%',
  height: '150px'
});